import { useState } from 'react';
import './VendorsPage.css';

function AdminVendorsPage() {
  const [formData, setFormData] = useState({
    name: '',
    businessType: '',
    city: '',
    phone: '',
    email: '',
    address: '',
    description: '',
    priceRange: '',
    rating: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    alert('Vendor added successfully!');
    setFormData({
      name: '',
      businessType: '',
      city: '',
      phone: '',
      email: '',
      address: '',
      description: '',
      priceRange: '',
      rating: '',
    });
  };

  return (
    <div className="admin-vendors-page">
      <div className="admin-form-card">
        <h2 className="admin-form-card-title">Add New Vendor</h2>
        <form className="admin-data-form" onSubmit={handleSubmit}>
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="name" className="admin-form-label">Vendor Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="admin-form-input"
                placeholder="Enter vendor/business name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="businessType" className="admin-form-label">Business Type *</label>
              <select
                id="businessType"
                name="businessType"
                className="admin-form-input"
                value={formData.businessType}
                onChange={handleChange}
                required
              >
                <option value="">Select type</option>
                <option value="photographer">Photographer</option>
                <option value="videographer">Videographer</option>
                <option value="makeup-artist">Makeup Artist</option>
                <option value="caterer">Caterer</option>
                <option value="decorator">Decorator</option>
                <option value="dj-sound">DJ & Sound</option>
                <option value="bridal-wear">Bridal Wear</option>
                <option value="groom-wear">Groom Wear</option>
                <option value="jewelry">Jewelry</option>
                <option value="mehendi-artist">Mehendi Artist</option>
              </select>
            </div>
          </div>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="city" className="admin-form-label">City *</label>
              <input
                type="text"
                id="city"
                name="city"
                className="admin-form-input"
                placeholder="Enter city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="phone" className="admin-form-label">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                className="admin-form-input"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="email" className="admin-form-label">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                className="admin-form-input"
                placeholder="Enter email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="admin-form-group">
            <label htmlFor="address" className="admin-form-label">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              className="admin-form-input"
              placeholder="Enter address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="description" className="admin-form-label">Description *</label>
            <textarea
              id="description"
              name="description"
              className="admin-form-textarea"
              placeholder="Enter vendor description"
              rows="4"
              value={formData.description}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="priceRange" className="admin-form-label">Price Range</label>
              <input
                type="text"
                id="priceRange"
                name="priceRange"
                className="admin-form-input"
                placeholder="e.g., ₹10,000 - ₹50,000"
                value={formData.priceRange}
                onChange={handleChange}
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="rating" className="admin-form-label">Rating</label>
              <input
                type="number"
                id="rating"
                name="rating"
                className="admin-form-input"
                placeholder="Enter rating (1-5)"
                min="1"
                max="5"
                step="0.1"
                value={formData.rating}
                onChange={handleChange}
              />
            </div>
          </div>

          <button type="submit" className="admin-submit-btn">
            Add Vendor
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminVendorsPage;
